import { Component, OnInit, Input, AfterViewInit, Renderer2 } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-menu-categories",
  templateUrl: "./menu-categories.component.html",
  styleUrls: ["./menu-categories.component.scss"],
})
export class MenuCategoriesComponent implements OnInit, AfterViewInit {
  @Input() modalObj;
  categoryList = [];
  activeCat = "";
  catName;
  contentHight: any;
  hideSubCat = true;

  constructor(public activeModal: NgbActiveModal, private renderer: Renderer2) { }

  ngOnInit() {
    this.categoryList = JSON.parse(JSON.stringify(this.modalObj.categoryLists));
    let length
    this.categoryList.forEach(element => {
      length = element.menuItems.length;
      if (element.hasSubCategories) {
        length = 0
        element.subCategories.forEach(element => {
          length += element['menuItems'].length
        });
      }
      element['length'] = length
    });
    this.activeCat = this.modalObj.currentlyActiveMenu;
    console.log(this.categoryList);
    this.currentlyActiveCat();
  }
  async ngAfterViewInit() {
    // this.contentHight = (await document.querySelector(".cat-list") as HTMLElement).offsetTop;
    // console.log(this.contentHight);
  }

  onCategoryFilter(category) {
    this.activeModal.close(category);
  }
  currentlyActiveCat() {
    console.log(this.activeCat)
    const activeMenu = this.activeCat.split(" ").slice(0, -1).join(" ");
    console.log(activeMenu)
    const copyCategory = JSON.parse(JSON.stringify(this.categoryList));
    const category = copyCategory.find(
      (ele) => {
        console.log(ele)
        console.log(ele.name.toLowerCase(), activeMenu.toLowerCase())
        return ele.name.toLowerCase() === activeMenu.toLowerCase()
      }
    );
    console.log(category);
    if (category) {
      this.catName = category?.name;
    } else {
      this.catName = this.categoryList[0].name;
    }
  }
  getMenuLength(category) {
    let length = category['menuItems'].length
    if (category.hasSubCategories) {
      length = 0
      category.subCategories.forEach(element => {
        length += element['menuItems'].length
      });
    }
    return length
  }

  toggle(index, catId) {
    this.categoryList[index].isCollapsed = !this.categoryList[index].isCollapsed
    console.log(catId)
    if (catId) {
      const icons = document.getElementById(catId)
      if (this.categoryList[index].subCategories.length > 0) {
        this.renderer.setAttribute(icons, 'src', "assets/icon/common/circle-minus.svg")
      } else {
        this.renderer.setAttribute(icons, 'src', "assets/icon/common/circle-plus.svg")
      }
    }
  }

  // async logScrolling(event) {
  //   console.log(event)
  //   const contentHeight = (await document.querySelector(".cat-list") as HTMLElement).offsetTop;
  //   const innerScroll = document.querySelector(
  //     ".menu-custom-scrollbar"
  //   );
  //   const percentageMovement =
  //     (event.detail.scrollTop * (100)) /
  //     contentHeight;
  //     console.log(percentageMovement)
  //   this.renderer.setStyle(
  //     innerScroll,
  //     "top",
  //     percentageMovement + "%"
  //   );

  // }
}
